import { SVGProps } from "react";

export const ArrowDownIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={props.width || "10"} height={props.height || "5"} viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 1L4.4 3.55C4.75556 3.81667 5.24444 3.81667 5.6 3.55L9 0.999999" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);
